import {GET_CURRENTUSER, SET_CURRENTUSER_LOADING, GET_CURRENTUSER_FAIL, CLEAR_CURRENTUSER} from '../actions/types'
const initialState = {
    currentUser: null,
    loadingUser:true,
    errorUser:null,
}
export default (state = initialState, action) => {
    switch (action.type) {
        case GET_CURRENTUSER:
            return{
                ...state,
                currentUser: action.payload,
                loadingUser:false
            }
        case SET_CURRENTUSER_LOADING:
            return{
                ...state,
                loadingUser:true
            }
        case GET_CURRENTUSER_FAIL:
            console.error(action.payload)
            return{
                ...state,
                errorUser:action.payload,
                loadingUser:false
            }
        case CLEAR_CURRENTUSER:
            return{
                ...state,
                currentUser:null
            }
        default:
            return {...state}
    }}